import {swipedetect} from '../../../../../../../ndsbase/Resources/Public/Assets/Js/Base/swipedetect.js';

export class SimpleSlider {
  constructor(sliderContainerElem, customConfig) {
    this.config = extend({}, {
      nav: {
        prevBtnSelector: '.js-simpleslider-prev',
        nextBtnSelector: '.js-simpleslider-next'
      },
      trackSelector: '.js-simpleslider-track',
      itemSelector: '.js-simpleslider-item',
      swipeSelector: null,
      slideDelta: 1,
      onInitCallback: null,
      afterSlideCallback: null,
      vertical: false,
      infinite: false,
      initSwipe: true,
      allowDisableNav: false,
      updateDisabledStates: true,
      autoSlide: false,
      autoSlideTimeout: 5000
    }, customConfig);
    this.currentSliderIndex = 0;
    this.containerElem = sliderContainerElem;
    this.trackElem = sliderContainerElem.querySelector(this.config.trackSelector);
    this.itemElements = this.trackElem.querySelectorAll(this.config.itemSelector);
    this.itemStyles = getComputedStyle(this.itemElements[0]);
    this.itemSpacing = (this.config.vertical) ? parseInt(this.itemStyles.marginBottom) : parseInt(this.itemStyles.marginRight);
    this.itemElemSize = (this.config.vertical) ? parseInt(this.itemElements[0].offsetHeight) : parseInt(this.itemElements[0].offsetWidth);
    this.itemElemSize = (this.itemSpacing) ? this.itemElemSize + this.itemSpacing : this.itemElemSize;
    this.visibleItems = Math.floor(sliderContainerElem.offsetWidth / this.itemElemSize);
    this.visibleItems = (this.visibleItems > 0) ? this.visibleItems : 1;
    this.swipeContainerElem = (this.config.swipeSelector) ? this.containerElem.querySelector(this.config.swipeSelector) : this.containerElem;
    this.prevBtn = sliderContainerElem.querySelector(this.config.nav.prevBtnSelector);
    this.nextBtn = sliderContainerElem.querySelector(this.config.nav.nextBtnSelector);
    this.userInteracted = false;
  }

  init() {
    this.trackElem.addEventListener('transitionend', function() {
      this.classList.remove('is-animatable')
    }, false);

    if (this.config.allowDisableNav) {
      if (this.itemElements.length > this.visibleItems) {
        this.initSliderNav();
        if(this.config.initSwipe) {
          this.initSwipe();
        }
      }
      else {
        this.prevBtn ? this.prevBtn.setAttribute('disabled', true) : null;
        this.nextBtn ? this.nextBtn.setAttribute('disabled', true) : null;
      }
    }
    else {
      this.initSliderNav();
      if(this.config.initSwipe) {
        this.initSwipe();
      }
    }

    if (this.config.updateDisabledStates) {
      this.updateDisabledStates();
    }

    if(typeof this.config.onInitCallback === 'function') {
      this.config.onInitCallback();
    }

    if (this.config.autoSlide) {
      this.autoSlide();
    }
  }

  autoSlide() {
    const autoSlideIntervalHandler = setInterval(() => {
      if (this.userInteracted) {
        clearInterval(autoSlideIntervalHandler);
        return;
      }
      this.navNext(undefined, 'com');
    }, this.config.autoSlideTimeout);
  }

  initSliderNav() {
    const event = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) ? 'touchstart' : 'click';

    if(this.prevBtn !== null) {
      this.prevBtn.addEventListener(event, e => this.navPrev(e, 'user'), { passive: true, capture: false });
    }

    if(this.nextBtn !== null) {
      this.nextBtn.addEventListener(event, e => this.navNext(e, 'user'), { passive: true, capture: false });
    }
  }

  initSwipe() {
    const _this = this;
    swipedetect(_this.swipeContainerElem, (swipedir, targetElem) => {
      if(_this.trackElem.classList.contains('is-animatable')) {
        return;
      }

      if((!_this.config.vertical && swipedir === 'left') || (_this.config.vertical && swipedir === 'up')) {
        if(_this.currentSliderIndex !== (_this.itemElements.length - 1)) {
          _this.slideElem(_this.config.slideDelta);
        } else {
          if(_this.config.infinite) {
            _this.goToSlide(0);
          }
        }
      }

      if((!_this.config.vertical && swipedir === 'right') || (_this.config.vertical && swipedir === 'down')) {
        if(_this.currentSliderIndex !== 0) {
          _this.slideElem(-1 * _this.config.slideDelta);
        } else {
          if(_this.config.infinite) {
            _this.goToSlide(_this.itemElements.length - 1);
          }
        }
      }

      if(swipedir === 'click') {
        let click = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        targetElem.dispatchEvent(click);
      }
    });
  };

  navPrev(e, calledFrom) {
    if (e !== undefined) {
      e.preventDefault();
    }

    if (calledFrom === 'user') {
      this.userInteracted = true;
    }

    if(this.currentSliderIndex !== 0) {
      this.slideElem(-1 * this.config.slideDelta);
    } else {
      if(this.config.infinite) {
        this.goToSlide(this.itemElements.length - 1);
      }
    }
  };

  navNext(e, calledFrom) {
    if (e !== undefined) {
      e.preventDefault();
    }

    if (calledFrom === 'user') {
      this.userInteracted = true;
    }

    if((this.currentSliderIndex + (this.visibleItems - this.config.slideDelta)) < this.itemElements.length - 1) {
      this.slideElem(this.config.slideDelta);
    } else {
      if(this.config.infinite) {
        this.goToSlide(0);
      }
    }
  };

  slideElem(delta) {
    // update item size on swipe
    this.itemElemSize = (this.config.vertical) ? parseInt(this.itemElements[0].offsetHeight) : parseInt(this.itemElements[0].offsetWidth);

    if(this.currentSliderIndex + delta > this.itemElements.length - 1) {
      delta = this.itemElements.length - 1 - this.currentSliderIndex;
    }
    if(this.currentSliderIndex + delta < 0) {
      delta = -1 * this.currentSliderIndex;
    }
    const targetIndex = this.currentSliderIndex + delta;
    const translateOption = (this.config.vertical) ? 'translateY' : 'translateX';
    let targetPositionDelta = 0;
    const targetPosition = -1 * ((targetIndex * this.itemElemSize) - targetPositionDelta);
    this.trackElem.classList.add('is-animatable');
    this.trackElem.style.transform = translateOption + '(' + targetPosition + 'px)';
    this.trackElem.querySelector('.is-active').classList.remove('is-active');
    this.currentSliderIndex = this.currentSliderIndex + delta;
    this.itemElements[this.currentSliderIndex].classList.add('is-active');

    if(typeof this.config.afterSlideCallback === 'function') {
      this.config.afterSlideCallback(this.currentSliderIndex);
    }
    if (this.config.updateDisabledStates) {
      this.updateDisabledStates();
    }
  }

  goToSlide(index) {
    const delta = index - this.currentSliderIndex;
    this.slideElem(delta);
  };

  updateDisabledStates() {
    if (this.currentSliderIndex === 0 && this.prevBtn !== null) {
      this.prevBtn.setAttribute('disabled', 'disabled');
    }
    else if (this.prevBtn !== null) {
      this.prevBtn.removeAttribute('disabled');
    }
    if (((this.currentSliderIndex + (this.visibleItems - this.config.slideDelta)) >= this.itemElements.length - 1) && this.nextBtn !== null) {
      this.nextBtn.setAttribute('disabled', 'disabled');
      this.trackElem.parentNode.classList.add('end')
    }
    else if (this.nextBtn !== null) {
      this.nextBtn.removeAttribute('disabled');
      this.trackElem.parentNode.classList.remove('end')
    }
    if (this.prevBtn !== null && this.prevBtn.getAttribute('disabled') === 'disabled'
      && this.nextBtn !== null && this.nextBtn.getAttribute('disabled') === 'disabled') {
      this.prevBtn.parentNode.classList.add('hidden');
    }
  }
}
